var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnnouncementPopup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 95,
    viewBox: "0 0 104 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2985 68.5917C26.9285 79.8135 40.7161 86.1789 55.094 82.8093C69.4719 79.4396 78.9955 67.6109 76.3655 56.3891C73.7355 45.1674 59.9479 38.802 45.57 42.1716C31.1921 45.5413 21.6686 57.37 24.2985 68.5917Z",
    fill: "#FFB858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4388 93.412L11.4248 65.4432L24.1425 47.9321L42.2882 57.9344L51.5948 67.6726L56.6981 54.3222L67.1475 51.475L74.3261 36.1709L102.91 72.2373L18.4388 93.412Z",
    fill: "#E6570E",
    stroke: "#FFB858",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9062 37.5947C59.6545 34.8281 63.2112 34.3945 62.9594 31.6279C62.7076 28.8612 59.1509 29.2948 58.8991 26.5282C58.6473 23.7616 62.204 23.328 61.9522 20.5613C61.7004 17.7947 58.1437 18.2283 57.8919 15.4617C57.6401 12.695 61.1969 12.2614 60.9451 9.49481",
    stroke: "#FFB858",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1152 38.2676C46.3141 35.6125 49.763 34.6237 48.9619 31.9686C48.1607 29.3135 44.7117 30.3023 43.9105 27.6472C43.1093 24.9921 46.5583 24.0034 45.7571 21.3483C44.956 18.6932 41.507 19.6819 40.7058 17.0268C39.9046 14.3717 43.3536 13.383 42.5524 10.7279",
    stroke: "#FFB858",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5156 43.8721C32.1164 41.4489 35.3065 39.8628 33.9072 37.4397C32.508 35.0166 29.3179 36.6027 27.9186 34.1795C26.5193 31.7564 29.7095 30.1703 28.3102 27.7471C26.911 25.324 23.7208 26.9101 22.3216 24.487C20.9223 22.0638 24.1124 20.4777 22.7132 18.0546",
    stroke: "#FFB858",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncementPopup);
export default __webpack_public_path__ + "static/media/announcement-popup.3eeff17f94c62ec6b1b90a50211d7db9.svg";
export { ForwardRef as ReactComponent };